/* eslint-disable no-unused-vars */

// set up the default state for the module
const initialState = {
  show: false,
  settings: {
    notifications: [],
  },
};

const actions = {
  openNotification: {
    root: true,
    handler({ commit, state }, settings) {
      commit('updateMessage', settings);
    },
  },
  closeNotification: {
    root: true,
    handler({ commit, state }) {
      commit('resetMessage');
    },
  },
};

const mutations = {
  updateMessage(state, settings) {
    if (settings) {
      const notificationData = {
        notificationType: settings.notificationType || 'success',
        title: settings.title || '',
        message: settings.message,
        action: settings.action,
        actionLabel: settings.actionLabel,
        showContactInfo: settings.showContactInfo,
        tinted: settings.tinted || false,
      };
      state.settings.notifications.push(notificationData);
    } else {
      const notificationData = {
        notificationType: 'success',
        title: '',
        message: '',
        action: '',
        actionLabel: '',
        showContactInfo: true,
        tinted: false,
      };
      state.settings.notifications = [{ ...notificationData }];
    }
  },
  resetMessage(state, payload) {
    state.settings.notifications = [];
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
